import { HttpClient, ListParams } from './http-client';
import { Observable } from 'rxjs';
import ClassifierValue from '../interfaces/classifierValue';
import Paginate from '../interfaces/paginate';
import FertilizerWithManureCorrections from '../interfaces/fertilizer-with-manure-corrections';

export class ClassifierService extends HttpClient {
  values(
    groupKey: string,
    classifierKey: string,
    params?: { [key: string]: any }
  ): Observable<ClassifierValue[]> {
    return this.get<ClassifierValue[]>(
      `/api/classifier-groups/${groupKey}/classifiers/${classifierKey}/values`,
      params
    );
  }

  valuesPaged(
    groupKey: string,
    classifierKey: string,
    params: { page: number; [key: string]: any }
  ): Observable<Paginate<ClassifierValue>> {
    return this.get(
      `/api/classifier-groups/${groupKey}/classifiers/${classifierKey}/values`,
      params
    );
  }

  publicValuesByParentId(
    groupKey: string,
    parentId: string
  ): Observable<ClassifierValue[]> {
    return this.get<ClassifierValue[]>(
      `/api/classifier-groups/${groupKey}/classifiers/values/parent/${parentId}`
    );
  }

  fertilizersWithManureCorrections(
    params: ListParams
  ): Observable<Paginate<FertilizerWithManureCorrections>> {
    return this.get<Paginate<FertilizerWithManureCorrections>>(
      `/api/classifiers/fertilizers-with-manure-corrections`,
      params
    );
  }
}
